module.exports = {
    path:"/home",
    component:()=>import("../../components/home/index.vue"),
    name:"首页",
}